// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Preloader_wrap__35phc","loadingWap":"Preloader_loadingWap__1Cm5g"};